<template lang="html">
  <div id="footer">
    <div class="link-list">
      <div class="link-li" @click="router('#product')">
        {{ $t('product_series') }}
      </div>
      <div class="link-li" @click="router('custom_x')">
        {{ $t('Gift Custom') }}
      </div>
      <div class="link-li" @click="router('feature')">
        {{ $t('App_introduce') }}
      </div>
      <div class="link-li" @click="goUserAgreement">
        {{ $t('user_agreement') }}
      </div>
      <div class="link-li" @click="goPolicy">
        {{ $t('privacy_policy') }}
      </div>
      <div class="lang__menu link-li">
      <div class="lang__list" v-show="langShow">
        <div
          class="lang__item"
          @click="switchLang($t.lang == 'cn' ? 'en' : 'cn')"
        >
          {{ $t.lang == 'en' ? '简体中文' : 'English' }}
        </div>
        <div
          class="lang__item lang__item--disable"
          @click="switchLang($t.lang == 'cn' ? 'cn' : 'en')"
        >
          {{ $t.lang == 'cn' ? '简体中文' : 'English' }}
        </div>
      </div>
      <div class="lang__current" @click="langShow = true">
        {{ $t.lang == 'cn' ? '简体中文' : 'English' }}
        <i class="icon_arrow"></i>
      </div>
    </div>
    </div>
    <div class="copyright">
      @Copyright <span>2020</span> {{ $t('_company_name') }}
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  data() {
    return {
      isEn: /\/en\//.test(window.location.href),
      langShow: false
    };
  },
  mounted() {
    let self = this;
    $('body').on('click', function(e) {
      if (e.target != document.querySelector('.lang__current')) {
        self.langShow = false;
      }
    });
  },
  methods: {
    switchLang(lang) {
      if (lang == 'en') {
        location.href = location.href.replace(/\/cn/, '/en');
      } else {
        location.href = location.href.replace(/\/en/, '/cn');
      }
    },
    goHome() {
      location.href = !this.isEn
        ? '//www.elfinbook.com/'
        : '//www.elfinbook.com/en';
    },
    router(path) {
      window.location.href =
        '//www.elfinbook.com/' + (this.isEn ? 'en/' : '') + path;
    },
    goUserAgreement() {
      window.location.href =
        'https://api.elfinbook.com/terms?lang=' + (this.isEn ? 'en' : 'zh');
    },
    goPolicy() {
      window.location.href =
        'https://api.elfinbook.com/privacy?lang=' + (this.isEn ? 'en' : 'zh');
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/common.scss';

#footer {
  /* width: 700px; */
  /* height:200px; */
  text-align: center;
  @include clearfix;
}

.link-list {
  @include clearfix;
  color: #666;
  font-size: 13px;
  display: inline-block;
}

.link-li {
  cursor: pointer;
  float: left;
  padding-right: 23px;
  height: 15px;
  line-height: 15px;
  margin-right: 23px;
  position: relative;

  &:not(:last-child) {
    border-right: 1px solid #d8d8d8;
  }
}

.copyright {
  margin: 5px 0 38px;
  font-size: 12px;
  color: #999;
  text-align: center;
}
// 语言
.lang__menu {
  position: relative;
  float: right;
  // color: #c6c6c6;
  font-size: 13px;
  width: 115px;
  padding-left: 0;
}
.lang__current {
  cursor: pointer;
}
.lang__list {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 140px;
  height: 80px;
  padding: 8px 0;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
}
.lang__item {
  width: 100%;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  color: #455a6c;
  &:hover {
    background: #f9f9f9;
  }
}
.lang__item--disable {
  color: #0dcbb8;
}
.icon_arrow {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: url(~@/assets/image/home_icon_arrow@2x.png) no-repeat 0 0 / 8px
    8px;
}
</style>
